import { Observable, switchMap, of, take } from "rxjs";
import { map, filter } from "rxjs/operators";
import { FormArray, UntypedFormGroup } from "@angular/forms";
import { FormBuilder, Validators } from "@angular/forms";
import _ from "lodash";
import {
  Dialog,
  DataService,
  SharedModule,
  ProductSelectorSearchQuery,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { Component, Input, OnInit } from "@angular/core";
import { FreeGiftCondition } from "../gifts.component";
import AddGiftComponent from "../Add-Gift/add.component";
import CreateGiftComponent from "../Create-Gift/create.component";
import GiftSelectorComponent from "./gift-selector/gift-selector.component";
import { FreeGiftsDocument } from "../../generated-graphql/graphql";
type SearchResult = ProductSelectorSearchQuery["search"]["items"][number];
type ProductVariant = FreeGiftCondition["productVariants"][0];
@Component({
  templateUrl: "./add-condition.component.html",
  standalone: true,
  imports: [SharedModule, GiftSelectorComponent, CreateGiftComponent],
})
export default class AddContidionDialogComponent implements Dialog, OnInit {
  constructor(
    protected dataService: DataService,
    private formBuilder: FormBuilder,
    private notiService: NotificationService
  ) {}
  resolveWith: (result?: any) => void;
  @Input() condition: FreeGiftCondition | null;
  @Input() productRetailer: string;
  @Input() productArtist: string;
  @Input() productName: string;
  @Input() detailForm: UntypedFormGroup;
  variants: ProductVariant[] = [];

  selected: any = null;

  conditionForm = this.formBuilder.group({
    minQuantity: [1, [Validators.required, Validators.min(1)]],
    giftQuantity: [1, [Validators.required, Validators.min(1)]],
    productVariants: this.formBuilder.array([], Validators.required),
  });

  get productVariants() {
    return this.conditionForm.get("productVariants") as FormArray;
  }

  addProductVariant(variant: string) {
    this.productVariants.push(this.formBuilder.control(variant));
  }

  removeProductVariant(index: number) {
    this.productVariants.removeAt(index)
  }

  productSelected(selectedVariant: ProductVariant) {
    if (this.variants.find((v) => v.id === selectedVariant.id)) {
      this.notiService.error("common.variantAlreadyAdded");
      return;
    }
    this.addProductVariant(selectedVariant.id);
    this.fetchVariant(selectedVariant.id).subscribe((variant) => {
      if (variant) {
        this.variants = _.concat(this.variants, variant);
      }
    });
  }

  ngOnInit(): void {
    this.mode = this.condition ? "edit" : "create";

    if (this.condition) {
      this.condition.productVariants.forEach((v) => {
        this.addProductVariant(v.id);
      });
      this.conditionForm.patchValue({
        minQuantity: this.condition.minQuantity,
        giftQuantity: this.condition.giftQuantity,
      });
      this.variants = this.condition.productVariants;
    }

    this.buttons = [
      {
        label: "common.close",
        type: "secondary",
        click: () => this.resolveWith(),
      },
      {
        label: "common.save",
        type: "primary",
        click: () => {
          this.resolveWith(this.conditionForm.value);
        },
      },
    ];
  }

  onSubmit() {}

  save() {}

  removeVariant(i: number) {
    this.removeProductVariant(i);
    this.variants = this.variants.filter((_, index) => index !== i);
  }

  fetchVariant(id: string): Observable<ProductVariant | undefined> {
    return of(id).pipe(
      switchMap((id) => this.dataService.product.getProductVariant(id).single$),
      filter((r) => r !== null),
      map((r) => {
        const tempVari = r.productVariant;
        if (tempVari) {
          return {
            id: tempVari.id,
            name: tempVari.name,
            stockLevel: tempVari.stockLevel,
            product: {
              featuredAsset: tempVari.product.featuredAsset,
            },
          };
        }
      })
    );
  }

  trackVari(_, i) {
    return i.id;
  }

  mode: "create" | "edit" = "create";
  buttons;

  addFreeGiftCreated(productId: string) {
    this.dataService
      .query(FreeGiftsDocument, {
        options: {
          filter: {
            productId: {
              eq: productId,
            },
          },
        },
      })
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (res.freeGifts && res.freeGifts.items.length > 0) {
          this.productSelected(res.freeGifts.items[0] as any);
        }
      });
  }
}
